




































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { AlsSejour } from '@/models/als/AlsSejour'
import SejourList from '@/views/reception/SejourList.vue'
import { AlsCommande } from '@/models/als/AlsCommande'
import { StatusCommande } from '@/enum/StatusCommande'

@Component({
  name: 'GestionSejour',
  components:{SejourList}
})
export default class GestionSejour extends Vue {
  private loading = false
  private showError = false      
  sejourTimerID = -1


  private get sejourList() {
    return this.$store.myGetters.sejourList
  }

  private get sejourInRoomList() {
    return this.$store.myGetters.sejourList.filter(s => new Date(s.sjrCheckIn) <= new Date())
  }

  private get sejourToComeList() {
    return this.$store.myGetters.sejourList.filter(s => new Date(s.sjrCheckIn) > new Date())
  }

  private get sejourToValidateList() {
    return this.$store.myGetters.sejourList.filter(s => !s.sjrEnable)
  }

  private get search(){
    return this.$store.myGetters.searchSejour
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_SEJOUR(value)
  }

  private get canRoomService(){
    return this.$store.myGetters.canRoomService
  }
  

  
  get nbCheckIn(){
    //@ts-ignore
    const today = this.$options.filters.formatDate(new Date(),"YYYY-MM-DD")
    //@ts-ignore
    return this.sejourList.filter(s => this.$options.filters.formatDate(s.sjrCheckIn,"YYYY-MM-DD") == today).length
  }

  get nbCheckOut(){
    //@ts-ignore
    const today = this.$options.filters.formatDate(new Date(),"YYYY-MM-DD")
    //@ts-ignore
    return this.sejourList.filter(s => this.$options.filters.formatDate(s.sjrCheckOut,"YYYY-MM-DD") == today).length
  }


  get nbToValidate(){
    return this.sejourToValidateList.length
  }


  get nbCommandeToValidate(){
    return this.$store.myGetters.commandeList.filter(s => s.panStatus == StatusCommande.EnAttenteValidation).length
  }
    
  created() {

    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 2)
    tomorrow.setHours(0,0,0,0)

    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    yesterday.setHours(0,0,0,0)
    
    const cmdFilter = {
      from:yesterday,
      to:tomorrow      
    } as AlsCommande

    this.loadSejours(cmdFilter)
    this.sejourTimerID = setInterval(()=>{this.loadSejours(cmdFilter)}, 60000);   
  }

  destroyed() {    
    clearInterval(this.sejourTimerID)
  }

  loadSejours(cmdFilter:AlsCommande){
    this.loading = true
    this.$store.myActions.ADM_SEJOUR_REQUEST({
      toCome:true
    } as AlsSejour).finally(() => {
      this.loading = false
    })
    //afin de reafraichir le nb de commande en attente
    this.$store.myActions.ADM_COMMANDE_REQUEST(cmdFilter)
  }

 
}
